export interface HRA_FORMULA_PROPS {
  basicSalary: number;
  dearnessAllowance: number;
  hraReceived: number;
  totalRent: number;
  metroCity: 'Yes' | 'No';
}
export const HRA_FORMULA = ({
  basicSalary,
  dearnessAllowance,
  hraReceived,
  totalRent,
  metroCity,
}: HRA_FORMULA_PROPS) => {
  if (
    basicSalary < 0 ||
    basicSalary > 100000000 ||
    dearnessAllowance < 0 ||
    dearnessAllowance > 10000000 ||
    hraReceived < 0 ||
    hraReceived > 100000000 ||
    totalRent < 0 ||
    totalRent > 100000000
  ) {
    return {
      actualHRA: 0,
      excessRent: 0,
      exemptedHra: 0,
      fortypercentOfBasicSalary: 0,
      fiftypercentOfBasicSalary: 0,
      hraChargeable: 0,
    };
  }
  let excessRentPaid = 0;
  const grossSalary = Number(basicSalary) + Number(dearnessAllowance);
  const percentOfSalary =
    metroCity === 'Yes' ? 0.5 * grossSalary : 0.4 * grossSalary;
  const tenpercentOfGross = 0.1 * grossSalary;
  if (Number(totalRent) - tenpercentOfGross >= 0) {
    excessRentPaid = Number(totalRent) - Number(tenpercentOfGross);
  }

  const exemptedHra = Math.min(
    excessRentPaid,
    percentOfSalary,
    Number(hraReceived)
  );
  const hraChargeable = Number(hraReceived) - Number(exemptedHra);

  return {
    actualHRA: hraReceived,
    excessRent: Math.round(excessRentPaid),
    exemptedHra: Math.round(exemptedHra),
    fortypercentOfBasicSalary: Math.round(percentOfSalary),
    fiftypercentOfBasicSalary: Math.round(percentOfSalary),
    hraChargeable: Math.round(hraChargeable),
  };
};
